/** @format */

import { createAction, props } from '@ngrx/store';

export const setCommonData = createAction('[Common] Set Commmon Data');
export const setCommonDsgVhHeader = createAction(
	'[Common] Set DSG_VH Header',
	props<{ dsgVh: string }>()
);

export const setCommonPageType = createAction(
	'[Common] Set Page Type',
	props<{ pageType: string }>()
);

// Useful when we want an effect to conditionally do nothing
export const noopAction = createAction('[Common] Do Nothing');
